import { post } from '../../base';

import { PosDashboardPayload, PosDashboardResponse } from './types-get';

export function getPosAnalyticsData(payload: PosDashboardPayload): Promise<PosDashboardResponse> {
  return post('alfred/v1/pos', { json: payload }).json();
}
